import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "800",
  height: "800",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--ci-primary-color, #000000)",
      class: "ci-primary",
      d: "M184 288h120v32H184zM184 216h184v32H184zM184 144h248v32H184zM184 72h312v32H184z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--ci-primary-color, #000000)",
      class: "ci-primary",
      d: "M95.196 16v417.568l-51.883-51.882-22.626 22.627 90.509 90.51 90.509-90.51-22.627-22.626-51.882 51.881V16h-32z"
    }, null, -1)
  ]))]))
}
export default { render };